<template>
  <div id="app">
    <router-view  :key="$router.currentRoute.fullPath"/>
    <!--<GoTop></GoTop>-->
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
    // 友盟统计添加

    const script = document.createElement("script");
    script.src = "https://s4.cnzz.com/z_stat.php?id=1280484927&web_id=1280484927";   //该路径为点击统计代码后，页面中第一个 文字统计 script代码
    script.language = "JavaScript";
    document.body.appendChild(script);
  },
  watch: {
    $route() {
      if (window._czc) {
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = "/";
        window._czc.push(["_trackPageview", contentUrl, refererUrl]);
      }
    }
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue